import { RootRouteWithBranding } from "@/components/Routing/RootRouteWithBranding";
import { buildBrandingHead } from "@/helpers/branding";
import { RootErrorComponent } from "@/components/Routing/RootError";
import { NotFoundLayout } from "@/layout/NotFoundLayout/NotFoundLayout";
import { queryClient } from "@/queryClient";
import { createRootRoute } from "@tanstack/react-router";
import { queries } from "@/services/branding/queries";

export const Route = createRootRoute({
  loader: async () => {
    const [branding, stylesheet] = await Promise.all([
      queryClient.ensureQueryData(queries.getBranding()).catch(() => null),
      queryClient.ensureQueryData(queries.getStylesheet()).catch(() => undefined),
    ]);

    return { branding, stylesheet };
  },
  head: ({ loaderData, matches }) => {
    return buildBrandingHead({
      matches,
      platformName: loaderData?.branding?.platformName,
    });
  },
  component: RootRouteWithBranding,
  notFoundComponent: () => <NotFoundLayout />,
  errorComponent: RootErrorComponent,
});
